<template>
  <div class="employeeTransferOrderList">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="gardenId1" :placeholder="detail.allHouse">
            <el-option key="0" :label="detail.allHouse" value="0"></el-option>
            <el-option v-for="item in tableData" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-button type="primary" @click="topics">{{$t('lang.btn_search')}}</el-button> -->
      </el-form>
    </div>
    <el-card>
      <el-form :rules="rules" ref="form" :model="form" label-width="134px" :label-suffix="require('@/config/enum').c_colon">
        <div class="location">{{$t('lang.lab_transferOrderPersonnel')}}
          <div style="font-size: 14px; color: #00b1c3;margin-top: 10px;">此操作包括转移：<br>工单状态为处理中、待评价的工单发单人、接单人、封单人；<br>全部状态的计划任务创建人、责任人。</div>
        </div>
        <!-- 转单人员 -->
        <el-form-item :label="$t('lang.lab_transferOrderID')" prop="transferOrder">
          <el-select v-model="form.transferOrder" filterable  :placeholder="$t('lang.lab_pleSelTransferOrder')">
            <el-option
              v-for="item in Orders"
              :key="item.id"
              :label="item.idNo"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 转接人员 -->
        <el-form-item :label="$t('lang.lab_forwarderID')" prop="transferStaff">
          <el-select filterable v-model="form.transferStaff" :placeholder="$t('lang.lab_pleSelTransferForwarder')">
            <el-option
              v-for="item in Staffs"
              :key="item.id"
              :label="item.idNo"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
          <el-button type="primary" class="btn-first" @click="commit('form')">{{$t('lang.btn_handle')}}</el-button>
      </el-form>    
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:employeeTransferOrderList
 *@Description:员工转单
 *@author:李斌
 *@Copyright:格众科技
 *@date:2020-03-30
 */
 import {
    mapGetters
  } from 'vuex'
export default {
  data() {
    return {
      form: {
        transferOrder: '', // 转单人员
        transferStaff: '', // 转接人员
      }, 
      rules: {
        transferOrder: [
          {
            required: true, message: this.$i18n.t('lang.lab_pleSelTransferOrder'), trigger: 'change'
          }         
        ],
        transferStaff: [
          {
            required: true, message: this.$i18n.t('lang.lab_pleSelTransferForwarder'), trigger: 'change'
          }         
        ]       
      },    
      Orders: [], // 转单人员列表     
      Staffs: [], // 转接人员列表
      operStaffId: '', // 账号编号 
      tableData: [], // 所有小区存储
      detail: this.$i18n.t('lang.eagleEye'),
      gardenId1: ''
    }
  },
  computed: {
    ...mapGetters(['gardenId'])
  },
  watch: {
    gardenId1(newVal, oldVal) {
        if (newVal != oldVal) {
          this.topics()
        }
      }
    },
  created() {
    this.gardenId1 = this.gardenId
    // 获取此账号的id
    this.operStaffId = this.$store.getters.staffId
    this.topics()
    this.gardens()
  },

  methods: {
     gardens() {
        let loading = this.$loading()
        this.$get(`/gardensByStaffId`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.tableData = res.list
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
    // 初始化
    topics() {
      this.form.transferOrder = ''
      this.form.transferStaff = ''
      let loading = this.$loading()
      this.$get(`/staffsNoPage?gardenId=${this.gardenId1}`).then(res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.Orders = res.list
            this.Staffs = res.list
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 办理
    commit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.form.transferOrder === this.form.transferStaff) {
            this.$message.error(this.$i18n.t('lang.lab_transfereeCannotSame'))            
          } else {
            let loading = this.$loading()
            this.$get(`/staffAdjustment?adjust=${this.form.transferOrder}&receive=${this.form.transferStaff}&operStaffId=${this.operStaffId}`).then(res => {
                loading.close()
                if (res && res.errCode === 0) {  
                    this.$message.success(this.$i18n.t('lang.lab_transferOrderPersonnelHandleSuc'))
                    this.topics()
                    this.form.transferOrder = ''
                    this.form.transferStaff = ''
                    setTimeout(() => {
                      this.$refs.form.clearValidate()
                    }, 0)
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )           
          }                           
        }
      })      
    }
  }
}
</script>

<style lang="scss">
.employeeTransferOrderList{
  .location{
    margin-top: 20px;
    margin-bottom: 20px;
    padding-left: 20px;
    font-size: 20px;
  }
}
</style>